export default "__VITE_ASSET__DQKWgNn6__"